module.exports = __webpack_public_path__ + "img/p201.d857889d.jpg";